// extracted by mini-css-extract-plugin
export default {"container":"HuqpRF","placeInfo":"wx04Ay","ticketInfo":"HW6KqO","ticketName":"rungI8","ticketNameContainer":"vLgBaK","priceOptionTicketName":"hG3neV","ticketPrice":"bU1oLL"};